import OrticaMaps from "../class/OrticaMaps";
import style from "../style/common";

class OrticaMapV2 extends OrticaMaps {
  static mapVersion = "v2";

  constructor(configs) {
    super(configs);

    this.markerImg = {
     // url:"https://maps.gstatic.com/mapfiles/api-3/images/spotlight-poi-dotless2.png",
      url: "/wp-content/themes/ortica/src/images/icons/marker.svg",
      // This marker is 20 pixels wide by 32 pixels high.
      size: new google.maps.Size(32, 32),
      // The origin for this image is (0, 0).
      origin: new google.maps.Point(0, 0),
      // The anchor for this image is the base of the flagpole at (0, 32).
      anchor: new google.maps.Point(0, 43),
    };
  }
  

  static init(mapConfigs) {
    return new this(mapConfigs)
      .setMapControls({
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: false,
        mapTypeControl: false,
        zoomControl: false,
      })
      .setStyle(style)
      .renderMap()
      .setMarkers()
      .attachMarkersToMap()
      .centerMapByMarker();
    // .attachSearchBar();
  }

  markup(location, i) {
    return `
			<div class="map__marker flex flex-wrap p-md border mb-sm" data-coordinate='${JSON.stringify(
        location.marker
      ).replace(/'/g, "\\'")}'>
				<div class="w-full md:w-6/12 flex items-center">
					<img src="${this.markerImg.url}" alt="">
					${location.shop.name}
				</div>
				<div class="w-full md:w-6/12">
					${location.shop.address}
				</div>
			</div>`;
  }

  setMarkers() {
    this.markers = this.locations.map((location, i) => {
      const marker = new google.maps.Marker({
        position: { lat: +location.marker.lat, lng: +location.marker.lng },
        title: location.item.name.replace(/<.*?>/g, ""),
        icon: this.markerImg,
        //label: String(i + 1),
        label: {
          text: String(i + 1),
          className: "marker_label",
          color: "#fff",
          fontSize: "14px",
          fontWeight: "500"
        },
      });

      if (location.marker.content) {
        const infowindow = new google.maps.InfoWindow({
          content: location.marker.content,
          // disableAutoPan: true,
        });

        marker.addListener("click", () => {
          this.map.panTo(marker.getPosition());
          infowindow.open(this.map, marker);
        });
      }

      return marker;
    });

    $(`#map__markers--${this.mapVersion}`).on(
      "click",
      this.goToPosition.bind(this)
    );
    return this;
  }
}

OrticaMapV2.load()
  .then((maps) => OrticaMapV2.init(maps))
  .catch(console.log);
